import moment from "moment";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CloseOnOutsideClick from "@/components/Common/CloseOnOutsideClick/CloseOnOutsideClick";
import DatePicker from "@/components/UI/DatePicker";
import { FormField, Input } from "@/component-library";
import { updateSelectedDate } from "@/redux/actions/calendar";

export const CalendarAppointmentDatePicker = () => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const dispatch = useDispatch();
  const selectedDate = useSelector((state) => state.calendar.selectedScheduleDate) || moment();

  const onDatePickerSelect = (newDate, changeType) => {
    if (changeType !== "monthChange") {
      const clonedSelectedDay = moment(newDate, "YYYY-MM-DD").local();

      dispatch(updateSelectedDate(clonedSelectedDay));
      setShowDatePicker(false);
    }
  };

  return (
    <FormField
      className="apti-CalendarAppointmentDateTimePicker--wrapped-fields"
      label="Date"
      style={{ position: "relative" }}
    >
      <>
        <Input
          className="apti-CalendarAppointmentDateTimePicker--input-wrapper"
          inputClassName="apti-CalendarAppointmentDateTimePicker--input"
          onClick={() => setShowDatePicker(true)}
          placeholder="Date"
          value={selectedDate.format("MMMM DD, YYYY")}
        />

        {showDatePicker && (
          <CloseOnOutsideClick setShowComponent={setShowDatePicker}>
            <div className="apti-CalendarAppointmentDateTimePicker--date-picker">
              <DatePicker externalCtx={selectedDate} onDaySelect={onDatePickerSelect} />
            </div>
          </CloseOnOutsideClick>
        )}
      </>
    </FormField>
  );
};
